
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import NarrowPage from "../../components/layout/narrow-page";
import Alert from "../../components/ui/alert";
import Head from "next/head";
import styles from "@/modules/register/styles/Register.module.css";
import { useRouter } from "next/router";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import { Button } from "@/components/ui/button";
export default function PasswordRecovery() {
    const [email, setEmail] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const { t } = useTranslation("common");
    const { t: registerT } = useTranslation("auth");
    const router = useRouter();
    function requestNewPassword() {
        const locale = router.locale;
        setLoadingBar(true);
        api
            .post("/password/create", { email, locale })
            .then(() => {
            setPasswordError(null);
            router.push("/signIn/recoveryEmailSent");
            setLoadingBar(false);
        })
            .catch(() => {
            setPasswordError(true);
        })
            .then(() => {
            setLoadingBar(false);
        });
    }
    return (<>
      <Head>
        <title>{"Chess Hotel | " + registerT("Password recovery")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <NarrowPage title={null}>
        <div className="text-lg font-semibold md:text-xl">
          {registerT("Password recovery")}
        </div>
        <div className="mt-5">
          <div className={styles.body}>
            {passwordError && <Alert>{registerT("Email not available")}</Alert>}
            <label htmlFor="email" className={styles.label}>
              {t("Email")}
            </label>
            <input id="email" autoFocus type="email" className="h-[48px] text-lg" onChange={(event) => setEmail(event.target.value)}/>

            <Button size="lg" className="py-7 mt-4 text-lg font-bold w-full" onClick={() => email && requestNewPassword()}>
              {t("Send")}
            </Button>
          </div>
        </div>
      </NarrowPage>
    </>);
}

    async function __Next_Translate__getStaticProps__19d12a5996a__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signIn/passwordRecovery',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19d12a5996a__ as getStaticProps }
  